import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(({ palette, shadows, spacing }) => ({
  card_promo: {
    background: palette.primary.main,
    borderRadius: spacing(1),
    boxShadow: shadows[5],
    color: palette.background.paper,
    padding: spacing(4),
  },
}));
